import "core-js/modules/es.object.values.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.includes.js";
import config from 'utils/config';
var CHECKLIST_I18N_KEYS = {
  THUMBNAIL: 'form_cover_image',
  DESCRIPTION: 'form_description',
  TAGS: 'content_type_tag_plural',
  TOPICS: 'content_type_topic_plural'
};
var CHECKLIST_ITEMS = Object.values(CHECKLIST_I18N_KEYS);
function hasArrayData(array) {
  return array && array.length > 0;
}
export default function getIncompleteContentFields(data) {
  var missingFields = [];
  if (!data.thumbnailId) {
    missingFields.push(CHECKLIST_I18N_KEYS.THUMBNAIL);
  }
  if (!data.description) {
    missingFields.push(CHECKLIST_I18N_KEYS.DESCRIPTION);
  }
  if (!hasArrayData(data.tags) && !hasArrayData(data.tagIds)) {
    missingFields.push(CHECKLIST_I18N_KEYS.TAGS);
  }
  if (!hasArrayData(data.topics) && !hasArrayData(data.topicIds)) {
    missingFields.push(CHECKLIST_I18N_KEYS.TOPICS);
  }
  if (!config.curationChecklist) {
    return {
      missingFields: missingFields,
      hasMissingFields: false,
      checklist: []
    };
  }
  var checklist = CHECKLIST_ITEMS.map(function (field) {
    return {
      fieldTranslationKey: field,
      exists: !missingFields.includes(field)
    };
  });
  return {
    missingFields: missingFields,
    hasMissingFields: missingFields.length > 0,
    checklist: checklist
  };
}